import ProfileBtn from "@/components/v2/common/v2-profile-btn";
import { useOrganizationContext } from "@/context";
import Link from "next/link";
import React from "react";
import DefaultHeaderBreadcrumb from "./default-header-breadcrumb";

type headerType = "default" | "logo";

interface IDefaultHeadaerProps {
  headerType?: headerType;
  collapsed: boolean;
  setCollapsed?: () => void;
}

const roleToString = (role?: string) => {
  if (role === "OWNER") {
    return "마스터";
  } else if (role === "MONITORING") {
    return (
      <span className="font-bold text-white bg-black">🚨모니터링중🚨</span>
    );
  } else {
    return "멤버";
  }
};

const DefaultHeader: React.FC<IDefaultHeadaerProps> = ({
  headerType = "default",
}) => {
  const { currentOrganization } = useOrganizationContext();

  if (headerType === "logo") {
    return (
      <div className="text-center sm:text-left">
        <Link href="/v2" legacyBehavior>
          <a className="inline-block mt-8 sm:mt-6 sm:ml-16" data-gtm-id="logo">
            <img src="/logo/v2-cb-logo.svg" alt="logo" />
          </a>
        </Link>
      </div>
    );
  }

  return (
    <nav
      className={`sticky top-0 z-40 flex items-center bg-white ${
        process.env.NEXT_PUBLIC_ENABLE_EMBED ? "hidden" : ""
      }`}
      style={{ height: "var(--header-height)" }}
    >
      <div className="relative flex items-center justify-between w-full h-full mx-6 text-base">
        {headerType === "default" && (
          <>
            <div>
              <DefaultHeaderBreadcrumb />
            </div>
            <div className="flex items-center flex-none">
              {currentOrganization && (
                <div className="flex flex-col mr-2 text-right">
                  <span className="text-sm truncate">
                    {currentOrganization.name}
                  </span>
                  <span className="text-xs text-cb-gray-700">
                    {roleToString(currentOrganization.userRole)}
                  </span>
                </div>
              )}

              <div>
                <ProfileBtn />
              </div>
            </div>
          </>
        )}
      </div>
    </nav>
  );
};

export default DefaultHeader;
